<template>
  <div id="wrapper" class="admin-panel admin-layout-wrapper">
    <t-side-nav></t-side-nav>
    <t-header></t-header>
    <div class="page-content admin-main-content">
      <div class="p-4 admin-content-container">
        <router-view />
      </div>
      <div class="admin-footer-wrapper">
        <t-footer :isCompanyPage="true"></t-footer>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/view/layouts/admin/Header";
import Footer from "@/view/layouts/shared/components/Footer.vue";
import SideNav from "@/view/layouts/admin/SideNav";
import { LOGOUT } from "@/core/services/store/auth.module";
//import "@/core/config/echo"
export default {
  name: "AdminLayout",
  components: {
    "t-header": Header,
    "t-footer": Footer,
    "t-side-nav": SideNav,
  },
  mounted() {
    // Todo check user has company admin role for access here
    let token = this.secureLocalStorage("token");

    let user = JSON.parse(this.secureLocalStorage("user"));
    let isAdmin = false;

    if (this.authUser && this.authUser.roles && this.authUser.roles.length) {
      isAdmin = this.authUser.roles.some((item) => item.name !== "user");
    }

    if (!token || !isAdmin) {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    }
  },
};
</script>

<style scoped>
/* Admin Layout - Footer en altta */
.admin-layout-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.admin-main-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.admin-content-container {
  flex: 1 1 auto;
}

.admin-footer-wrapper {
  flex-shrink: 0;
  margin-top: auto;
}
</style>
